import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import services from './services.js';
//组件
import baseInfoForm from '../../../components/agent-base-infonew';
import contactForm from '../../../components/agent-contactnew';
import agentInfo from '../../../components/agent-infonew';
import selectStaffDialog from 'selectStaffDialog';
import chooseDialog from "@pages/Order/MeetOrder/components/chooseDialog/index.vue" //选择代理商、园所弹窗

//import address from 'agent-address';
export default {
    mixins: [services],
    components: {
        'base-info-form': baseInfoForm,
        'contact-form': contactForm,
        'agent-info': agentInfo,
        selectStaffDialog,
        chooseDialog
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            choiceAgentInfoIndex: '',
            agentInfoNum: 1,
            agentList: [{}],
            baseInfo: null,
            contact: null,
            address: null,
            id: 0,
            CustomerId: 0,
            title: '',
            isReadOnly: false,
            form: this.getFormData(),
            agentInfo: this.getAgentInfo(),
            dialogObj: '', //判断是招商还是业务经理
            isRequired: false, //判断必填字段
            isAddBtnShow: [true],
            isDelBtnShow: [false],
            isOnlyHiInter: false, //判断是不是只代理hi幼教意向级别
            isShow: false,
            currentProject: '',
            currentLevel: '',
            AgentAreaId: ""
        };
    },
    computed: {
        sysSid: function () {
            return this.$store.state.sysSid;
        },
        sysSession: function () {
            return this.$store.state.sysSession;
        }
    },
    watch: {
        isShow() {
            if (this.isShow) {
                this.GetById()
                this.form.IsUpdateContactOrCustomer = 1

            } else {

                this.baseInfo = null
                this.contact = null
                this.form.IsUpdateContactOrCustomer = 0
            }

        }
    },
    methods: {
        getAgentInfo() {
            return cloneDeep({
                Customer: '',
                AgentTel: '',
                Address: '',
                C_Name: '',
                AgentStyle: ''
            });
        },
        getFormData() {
            return cloneDeep({
                Id: 0, //传的是代理商id
                Contact: {},
                Customer: {},
                IsUpdateContactOrCustomer: 0, //有填基本信息时候为1
            });
        },
        removeList(index) {
            if (index !== -1) {
                this.examineData.ListDoubt.splice(index, 1)
                this.isAddBtnShow.shift(false)
                this.isDelBtnShow.pop(true)
            }
        },
        // 选择代理商
        chooseAgent() {
            this.$refs.chooseDialog.show({
                title: '选择代理商',
                isCommon: true,
                AgentStyle: 2
            });
        },
        // 获取代理商数据
        getDialogList(item) {
            console.log(item)
            this.form.Id = item.Id
            this.id = item.Id
            this.agentInfo = util.filterAndSetData(this.agentInfo, item)
            this.GetAgentAreaList(item.Id)
        },
        getFlag(val) {
            this.isShow = true
        },
        getProject(val) {
            this.currentProject = val
        },
        getLeve(val) {
            this.currentLevel = val
        },
        initData() {
            this.loading = false
            this.form = this.getFormData()
            this.agentInfo = this.getAgentInfo()
            this.currentProject = ''
            this.currentLevel = ''
            this.isOnlyHiInter = false
            this.isShow = false
            this.CustomerId = 0
            this.id = 0
        },
        show(options) {
            this.initData()
            this.dialogVisible = true
            this.title = options.title

            this.isReadOnly = options.isReadOnly
            this.$nextTick(() => {
                this.form = this.getFormData()
                this.$refs.baseInfo.resetFields();
                this.$refs.contactAfter.resetFields();
                this.agentList = [{}];
                for (let i = 0; i < this.agentList.length; i++) {
                    this.$refs['agentInfo' + (i + 1)][0].resetFields();
                }

                this.agentInfoNum = 1;
            })
            if (options.Id) {
                this.id = options.AgentId //代理商Id
                this.CustomerId = options.Id
                this.AgentAreaId = options.AgentAreaId

                this.agentInfo.Customer = options.msg.Customer
                this.agentInfo.C_Name = options.msg.CName
                this.agentInfo.AgentTel = options.msg.CTel
                this.agentInfo.Address = options.msg.AgentProvincesName + options.msg.AgentCityName + options.msg.AgentAreaName
                // 修改获取单条
                this.GetByCustomerAreaId(options.Id, options.AgentAreaId)
            }

        },

        showSelectStaffDialog(val) {
            this.dialogObj = val
            this.$refs.refSelectStaffDialog.show();
        },
        //选择员工
        selectedStaff(item) {
            //lg(item);
            if (this.dialogObj == 'Manager') {
                // 招商经理信息
                this.$refs.baseInfo.setStaffInfo2(item);
            } else {
                this.$refs.baseInfo.setStaffInfo(item);
            }

        },
        //关闭弹窗
        close() {

            this.dialogVisible = false;
        },
        //添加代理基本信息
        addAgentObj() {
            this.agentList.push({});
        },
        addAgent() {
            this.agentInfoNum += 1;
        },
        delAgentfn(item) {
            this.agentList.splice((item.index - 1), 1);
        },

        submit() {

            this.$nextTick(() => {
                // 新增 修改提交
                let contact = false
                let baseInfo = false
                if (this.isShow) {
                    contact = this.$refs.contactAfter.validate(); //联系人信息
                    if (contact) {
                        baseInfo = this.$refs.baseInfo.validate(); //公司基本信息
                    }
                    this.form.IsUpdateContactOrCustomer = 1
                } else {
                    contact = true
                    baseInfo = true
                    this.form.IsUpdateContactOrCustomer = 0
                }

                let ListAgentAreas = [];
                if (baseInfo || !this.isShow) {
                    //合作信息
                    for (let i = 0; i < this.agentList.length; i++) {
                        let dataArea = this.$refs['agentInfo' + (i + 1)][0].validate();
                        ListAgentAreas.push(dataArea);
                    }

                }
                let agentInfoResult = ListAgentAreas.every(function (result) {
                    return result;
                });

                if (!!baseInfo && !!contact && agentInfoResult) {
                    if (this.isShow) {
                        this.form.Contact = cloneDeep(contact)
                        this.form.Customer = cloneDeep(baseInfo)
                    }

                    this.form.List = cloneDeep(ListAgentAreas)
                    if (this.form.Id == 0) {
                        this.$notify({
                            title: '警告',
                            message: '请选择代理商',
                            type: 'warning'
                        });
                        return;
                    }
                    if (this.title == '修改') {
                        this.form.Id = this.id
                        this.form.List[0].Id = this.AgentAreaId
                        this.UpdateAgentArea(this.form)
                    } else {
                        this.AddAgentArea(this.form)
                    }



                }

            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMAgentManage/AgentAreaList/components/AddAreaDialog/vm.js